import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export function getComponentLocale(props, context, componentName, getDefaultLocale) {
  var locale = {};

  if (context && context.beeLocale && context.beeLocale[componentName]) {
    locale = context.beeLocale[componentName];
  } else {
    var defaultLocale = getDefaultLocale();
    locale = defaultLocale.default || defaultLocale;
  }

  var result = _objectSpread(_objectSpread({}, locale), props.locale);

  if (props.locale) {
    result.lang = _objectSpread(_objectSpread({}, locale.lang), props.locale.lang);
  } else {
    result.lang = _objectSpread({}, locale.lang);
  }

  return result;
}
export function getLocaleCode(context) {
  var localeCode = context.beeLocale && context.beeLocale.lang; // Had use LocaleProvide but didn't set locale

  if (context.beeLocale && context.beeLocale.exist && !localeCode) {
    return 'zh-cn';
  }

  return localeCode;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-locale/src/tool.js